module.exports = __webpack_public_path__ + "media/app/assets/imgs/exchange/connect_confirmed-00f2bffe3203f9d84006a6112f2e35ec.png";